import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AutoComplete, Input } from "antd";
import "../style.css";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { VaporChip, VaporRangeDatePicker } from "../../vapor";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getFulfilments } from "../../../store/actions/fulfilments";
import moment from "moment";

const FulfilmentFilters = (props) => {
  const { dateFromValue, setDateFromValue, dateToValue, setDateToValue, customerId, setCustomerId, setFirstLoaded } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const filteredCustomers = useSelector((state) => state.fulfilments.filteredCustomers);
  const auth = useSelector((state) => state.auth);
  const main = useSelector((state) => state.main);
  const [activeChip, setActiveChip] = useState("all");

  const [companyOptions, setCompanyOptions] = useState([]);
  const [searchValue, setSearchValue] = useState(null);

  useEffect(() => {
    if (filteredCustomers) {
      setCompanyOptions(
        filteredCustomers.map((customer) => {
          return { value: customer.id, label: customer.customerName };
        })
      );
    }
  }, [filteredCustomers]);

  useEffect(() => {
    if (dateFromValue && dateToValue) {
      dispatch(
        getFulfilments({
          auth,
          managerId: main.accountantUuidSelected,
          fromDate: moment(dateFromValue).format("YYYY-MM-DD"),
          toDate: moment(dateToValue).format("YYYY-MM-DD"),
        })
      );
    }
    if (!dateFromValue && !dateToValue) {
      dispatch(
        getFulfilments({
          auth,
          managerId: main.accountantUuidSelected,
        })
      );
    }
  }, [dateFromValue, dateToValue]);

  useEffect(() => {
    let items = [];
    filteredCustomers.map((customer) => {
      if (!searchValue || (searchValue && customer.customerName.toLowerCase().indexOf(searchValue.toLowerCase()) > -1)) {
        items.push({
          value: customer.itemId,
          label: customer.customerName,
        });
      }
      return null;
    });
    setCompanyOptions(items);
  }, [searchValue]);

  const [timer, setTimer] = useState(null);
  const debouncedSearchHandler = (value) => {
    if (timer !== null) clearTimeout(timer);
    setTimer(
      setTimeout(() => {
        setSearchValue(value);
      }, 300)
    );
  };

  return (
    <div className={"fulfilment-filters-container"}>
      <div className={"fulfilment-filters-row"}>
        {!customerId && (
          <div className={"fulfilment-search"}>
            <div style={{ paddingBottom: 10 }}>
              <FormattedMessage id="fulfilments.searchFilter" />
            </div>
            <AutoComplete
              className="fulfilment-search-autocomplete"
              options={companyOptions}
              onSelect={(val) => {
                navigate("/fulfilments?customerId=" + val);
                setFirstLoaded(false);
                setCustomerId(val);
              }}
              onSearch={debouncedSearchHandler}
            >
              <Input.Search
                size="large"
                className="fulfilment-search-input"
                placeholder="Cerca per C.F., P.IVA o ragione sociale"
                enterButton={<FontAwesomeIcon icon={["fal", "search"]} />}
              />
            </AutoComplete>
            {/* <Input
            className={"fulfilment-search-input"}
            value={searchValue}
            onChange={e => setSearchValue(e.target.value)}
            placeholder={"Cerca per C.F., P.IVA o ragione sociale"}
            suffix={
              <Button style={{ marginRight: -8 }} onClick={() => renderFilteredList(searchValue)}>
                <FontAwesomeIcon icon={["far", "search"]} />
              </Button>
            }
          /> */}
          </div>
        )}
        <div className={"fulfilment-date"}>
          <div style={{ paddingBottom: 10 }}>
            <FormattedMessage id="documents.filters.selectPeriod" />
          </div>
          <VaporRangeDatePicker
            className={"fulfilment-date-input"}
            placeholder={["Data inizio", "Data fine"]}
            suffixIconStyle={{ marginRight: "-5px" }}
            value={[dateFromValue, dateToValue]}
            onChange={(e) => {
              if (e && e.length !== 0) {
                setDateFromValue(e[0]);
                setDateToValue(e[1]);
              } else {
                setDateFromValue(null);
                setDateToValue(null);
              }
            }}
          />
        </div>
      </div>
      <div className={"fulfilment-filters-row"}>
        <div className={"fulfilment-filters-chips"}>
          {["all", "accounting", "fiscals", "management"].map((kind, index) => {
            return (
              <VaporChip
                key={index}
                onClick={() => setActiveChip(kind)}
                title={useIntl().formatMessage({ id: "fulfilments.create.filters.kinds." + kind })}
                active={activeChip === kind}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FulfilmentFilters;
